export const flowDiscoverZH = {
  flowDiscover1: '视频',
  flowDiscover2: '专区',
  flowDiscover3: '热门话题',
  flowDiscover4: '输入关键词',
  flowDiscover5: '最新',
  flowDiscover6: '刷一刷',
  flowDiscover7: '必看榜',
  flowDiscover8: '唠一唠',
  flowDiscover9: '推荐',
  flowDiscover10: '直播',
  flowDiscover11: '俱乐部报告',
  flowDiscover12: '文章',
  flowDiscover13: '快来说说你的想法吧',
  flowDiscover14: '视频上传中',
  flowDiscover15: '继续上传照片',
  flowDiscover16: '上传中',
  flowDiscover17: '上传照片',
  flowDiscover18: '上传视频',
  flowDiscover19: '参与话题',
  flowDiscover20: '取消',
  flowDiscover21: '发布',
  flowDiscover22: '添加话题',
  flowDiscover23: '添加话题，动态会更容易让小伙伴发现。',
  flowDiscover24: '没有相关动态哦～',
  flowDiscover25: '确定删除该动态吗？',
  flowDiscover26: '搜索话题',
  flowDiscover27: '热搜话题：',
  flowDiscover28: '添加',
  flowDiscover29: '上传失败，请重新上传',
  flowDiscover30: '目前只支持图片格式文件！',
  flowDiscover31: '我是有底线的~',
  flowDiscover32: '确定',
  flowDiscover33: '此内容已被删除',
  flowDiscover34: '登录/注册',
  flowDiscover35: '关注',
  flowDiscover36: '粉丝',
  flowDiscover37: '投稿',
  flowDiscover38: '我的投稿',
  flowDiscover39: '确定取消关注吗？',
  flowDiscover40: '提示',
  flowDiscover41: '打卡成功',
  flowDiscover42: '打卡',
  flowDiscover43: '一',
  flowDiscover44: '二',
  flowDiscover45: '三',
  flowDiscover46: '四',
  flowDiscover47: '五',
  flowDiscover48: '六',
  flowDiscover49: '日',
  flowDiscover50: '积分',
  flowDiscover51: '查看全部',
  flowDiscover52: '赞',
  flowDiscover53: '评论',
  flowDiscover54: '刚刚',
  flowDiscover55: '点赞',
  flowDiscover56: '大家都在讨论',
  flowDiscover57: '人参与',
  flowDiscover58: '分享你的想法吧~',
  flowDiscover59: '签到成功',
  flowDiscover60: '阅读成功',
  flowDiscover61: '点赞成功',
  flowDiscover62: '评论成功',
  flowDiscover63: '投票成功',
  flowDiscover64: '发帖成功',
  flowDiscover65: '投稿成功',
  flowDiscover66: '喜欢它',
  flowDiscover67: '阅读',
  flowDiscover68: '收起'
}

export const flowDiscoverEN = {
  flowDiscover1: 'Video',
  flowDiscover2: 'Zone',
  flowDiscover3: 'Trending Topics',
  flowDiscover4: 'Enter a keyword',
  flowDiscover5: 'Latest',
  flowDiscover6: 'Sharing',
  flowDiscover7: 'Learning',
  flowDiscover8: `Chatting`,
  flowDiscover9: 'Recommend',
  flowDiscover10: 'Live Streams',
  flowDiscover11: 'Club Reports',
  flowDiscover12: 'Essay',
  flowDiscover13: 'Let us know what you think',
  flowDiscover14: 'Video uploading',
  flowDiscover15: 'Proceed to upload photos',
  flowDiscover16: 'Uploading',
  flowDiscover17: 'Upload a photo',
  flowDiscover18: 'Upload a video',
  flowDiscover19: 'Participating Topics',
  flowDiscover20: 'Cancel',
  flowDiscover21: 'Publish',
  flowDiscover22: 'Add a topic',
  flowDiscover23: 'Add a topic, and the dynamics will be easier for friends to discover your post. ',
  flowDiscover24: 'There is no related posts~',
  flowDiscover25: 'Are you sure you want to delete the post?',
  flowDiscover26: 'Search Topic',
  flowDiscover27: 'Trending topics:',
  flowDiscover28: 'Add',
  flowDiscover29: 'Upload failed, and please upload it again',
  flowDiscover30: 'Currently, only image format files are supported!',
  flowDiscover31: 'I have a bottom line~',
  flowDiscover32: 'Confirm',
  flowDiscover33: 'This content has been removed',
  flowDiscover34: 'Log In / Sign Up',
  flowDiscover35: 'Follow',
  flowDiscover36: 'Follower',
  flowDiscover37: 'Submission',
  flowDiscover38: 'My Contributions',
  flowDiscover39: 'Are you sure to unfollow?',
  flowDiscover40: 'Prompt',
  flowDiscover41: 'Clocked in',
  flowDiscover42: 'Clock-in',
  flowDiscover43: 'Mon',
  flowDiscover44: 'Tues',
  flowDiscover45: 'Wed',
  flowDiscover46: 'Thur',
  flowDiscover47: 'Fri',
  flowDiscover48: 'Sat',
  flowDiscover49: 'Sun',
  flowDiscover50: 'Points',
  flowDiscover51: 'View All',
  flowDiscover52: 'Like',
  flowDiscover53: 'Comment',
  flowDiscover54: 'Just now',
  flowDiscover55: 'Like',
  flowDiscover56: `Everyone's talking about`,
  flowDiscover57: 'participant(s)',
  flowDiscover58: 'Share your ideas~',
  flowDiscover59: 'Clock-in successfully',
  flowDiscover60: 'Read successfully',
  flowDiscover61: 'Likes successfully',
  flowDiscover62: 'Comment successfully',
  flowDiscover63: 'Vote successfully',
  flowDiscover64: 'Post successfully',
  flowDiscover65: 'Contribute successfully',
  flowDiscover66: 'Likes',
  flowDiscover67: 'read',
  flowDiscover68: 'Retract'
}



// WEBPACK FOOTER //
// ./src/i18n/langs/flow/discover.js